import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import reducer from '../reducers';
import * as actionsTypes from '../actions/types';

let persistedState = {};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const resetEnhancer = (rootReducer) => (state, action) => {
  if (action.type !== actionsTypes.LOGOUT) return rootReducer(state, action);

  const newState = rootReducer(undefined, {});
  return newState;
};

export const configureStore = () => {
  const middleware = [thunk];

  if (process.env.NODE_ENV !== 'production') {
    // middleware.push(logger);
  }

  const store = createStore(
    resetEnhancer(reducer),
    persistedState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  return store;
};

const store = configureStore();

export default store;
